<template>
    <div>
        <multiselect
                v-bind:value="internalCounties"
                track-by="statevalue"
                label="name"
                placeholder="Search"
                v-bind:options="countyOptions"
                v-bind:multiple="true"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                v-bind:close-on-select="false"
                v-bind:clear-on-select="false"
                v-on:input="setCounties"
        >
            <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
                    v-if="values.length > 5 && !isOpen"
                    v-bind:class="{'someselected': values.length !== countyOptions.length}"
            >{{ values.length }} Counties selected</span>
                <span
                        v-else-if="values.length && !isOpen"
                        v-bind:class="{'someselected': values.length !== countyOptions.length}"
                >{{ values.map(x => x.name).join(', ')}}</span>
            </template>
            <template slot="tag">
                <span></span>
            </template>
        </multiselect>
        <multiselect
                v-bind:value="internalMcds"
                track-by="mcd"
                label="name"
                placeholder="Search"
                v-bind:options="boundaryNamesForCounties"
                v-bind:multiple="true"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                v-bind:close-on-select="false"
                v-bind:clear-on-select="false"
                v-on:input="setMcd"
        >
            <template slot="selection" slot-scope="{ values }">
                <span
                        v-if="values.length > 5"
                        v-bind:class="{'someselected': values.length !== boundaryNamesForCounties.length}"
                >{{ values.length }} Communities selected</span>
                <span
                        v-else-if="values.length"
                        v-bind:class="{'someselected': values.length !== boundaryNamesForCounties.length}"
                >{{ values.map(x => x.name).join(', ')}}</span>
            </template>
            <template slot="tag">
                <span></span>
            </template>
        </multiselect>
    </div>
</template>

<script>
    export default {
        name: "mcdSelect",
        props: [ 'boundaryNames', 'counties', 'mcd'],
        data: function () {
            return {
                internalCounties: [],
                internalMcds: [],
            }
        },
        computed: {
            countyOptions: function () {
                return [
                    {"name": "Livingston", "statevalue": 93},
                    {"name": "Macomb", "statevalue": 99},
                    {"name": "Monroe", "statevalue": 115},
                    {"name": "Oakland", "statevalue": 125},
                    {"name": "St. Clair", "statevalue": 147},
                    {"name": "Washtenaw", "statevalue": 161},
                    {"name": "Wayne", "statevalue": 163},
                ]
            },
            countiesLookup: function () {
                let lookup = {};
                this.countyOptions.forEach(o => lookup[o.statevalue] = o);
                return lookup;
            },
            selectedCountiesLookup: function () {
                let selected = {};
                if (this.internalCounties.length === 0) {
                    this.countyOptions.forEach(o => selected[o.statevalue] = o);
                }
                this.internalCounties.forEach(o => selected[o.statevalue] = o);
                return selected;
            },
            mcdLookup: function () {
                let lookup = {};
                this.boundaryNames.forEach(o => lookup[o.mcd] = o);
                return lookup;
            },
            boundaryNamesForCounties: function () {
                return this.boundaryNames.filter(c => this.selectedCountiesLookup[c.county]);
            },
        },
        methods: {
            setCounties: function (ids) {
                let old_counties_lookup = {};
                this.internalCounties.forEach(o => old_counties_lookup[o.statevalue] = o);
                if (ids.length === 0) {
                    if (this.internalCounties.length === 1) {
                        this.internalCounties = this.countyOptions.filter(c => c.statevalue !== this.internalCounties[0].statevalue);
                    } else {
                        this.internalCounties = this.countyOptions;
                    }
                } else if (ids.length + 1 === this.countyOptions.length && this.internalCounties.length === this.countyOptions.length) {
                    this.internalCounties = [this.countyOptions.find(c => !ids.includes(c))];
                } else {
                    this.internalCounties = ids;
                }
                let old_selected_mcd_lookup = {};
                this.internalMcds.forEach(o => old_selected_mcd_lookup[o.mcd] = o);
                let new_mcds = this.boundaryNamesForCounties.filter(c => !old_counties_lookup[c.county] || old_selected_mcd_lookup[c.mcd]);
                if (new_mcds.length === 0) {
                    this.internalMcds = this.boundaryNamesForCounties;
                } else {
                    this.internalMcds = new_mcds;
                }
                this.$emit('countiesInput', this.internalCounties);
                this.emitMcd();
            },
            setMcd: function(ids) {
                if (ids.length === 0) {
                    if (this.internalMcds.length === 1) {
                        this.internalMcds = this.boundaryNamesForCounties.filter(c => c.mcd !== this.internalMcds[0].mcd);
                    } else {
                        this.internalMcds = this.boundaryNamesForCounties;
                    }
                } else if (ids.length + 1 === this.boundaryNamesForCounties.length && this.internalMcds.length === this.boundaryNamesForCounties.length) {
                    this.internalMcds = [this.boundaryNamesForCounties.find(c => !ids.includes(c))];
                } else {
                    this.internalMcds = ids.filter(c => this.selectedCountiesLookup[c.county]);
                }
                this.emitMcd();
            },
            emitMcd: function () {
                let new_mcds = 0;
                if (this.internalMcds.length === 0 || this.internalMcds.length === this.boundaryNames.length) {
                    new_mcds = 0;
                } else if (this.internalMcds.length === 1) {
                    new_mcds = this.internalMcds[0].mcd;
                } else {
                    new_mcds = this.internalMcds.map(c => c.mcd).sort((a, b) => a - b);
                }
                if (this.boundaryNames && JSON.stringify(new_mcds) !== JSON.stringify(this.mcd)) {
                    this.$emit('mcdInput', new_mcds);
                }
            },
            fixInternalToMatchMcd: function () {
                if (!this.mcd) {
                    this.internalMcds = this.boundaryNamesForCounties;
                } else if (!Array.isArray(this.mcd)) {
                    this.internalMcds = [this.mcdLookup[this.mcd]];
                } else {
                    this.internalMcds = this.mcd.map(c => this.mcdLookup[c]).filter(c => c).filter(c => this.selectedCountiesLookup[c.county]);
                }
            },
        },
        watch: {
            counties: {
                immediate: true,
                handler: function () {
                    if (!this.counties || !this.counties.length) {
                        this.internalCounties = this.countyOptions;
                    } else {
                        this.internalCounties = this.counties.map(c => this.countiesLookup[c.statevalue]).filter(c => c);
                    }
                    this.fixInternalToMatchMcd();
                },
            },
            mcd: function () {
                this.fixInternalToMatchMcd();
            },
        },
    }
</script>

<style scoped>
    /deep/ .multiselect__option--selected.multiselect__option--highlight {
      background: #41b883;
    }

    /deep/ .multiselect__option--selected.multiselect__option--highlight:after {
      background: #41b883;
    }

    /deep/ .multiselect__option--group-selected.multiselect__option--highlight {
      background:#41b883;
    }

    /deep/ .multiselect__option--group-selected.multiselect__option--highlight:after {
      background: #41b883;
    }

    /deep/ .multiselect__option>span:before {
      content: "☐ ";
    }

    /deep/ .multiselect__option--selected>span:before {
      content: "☑ ";
    }

    /deep/ .multiselect__tags>input {
        margin-top: 10px;
    }

    /deep/ .someselected {
        font-weight: bold;
        color: #000;
    }
</style>
